import React from "react";
import Dashboard from "../components/Dashboard";

const Dashboardpage = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default Dashboardpage;
